import {match} from 'ts-pattern';

import {LineHeight} from './lineHeightToValue';

type ActionButtonSize = 'small' | 'default';

/**
 * Returns the IconButton size for row action buttons.
 *
 * Matches the header cell button sizing logic:
 * - Mobile: always 'small' (24 px)
 * - COMPACT / SHORT / DEFAULT row height: 'small' (24 px)
 * - TALL / THUMBNAIL row height: 'default' (32 px)
 */
export function getActionButtonSize(rowHeight: LineHeight, isMobile: boolean): ActionButtonSize {
  if (isMobile) {
    return 'small';
  }

  return match(rowHeight)
    .with('COMPACT', 'SHORT', 'DEFAULT', () => 'small' as const)
    .with('TALL', 'THUMBNAIL', () => 'default' as const)
    .exhaustive();
}
